import React from 'react';
import './loading.scss';

export const Loading = () => {
  return (
    <div className={'loading'}>

      <div className='loading_loader'>
        <div className='loading_loader_outer' />
        <div className='loading_loader_middle' />
        <div className='loading_loader_inner' />
      </div>
    </div>

  );
};

